"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsContentScrollView = exports.TermsContentScrollViewDefaultProps = exports.TERMS_CONTENT_QUERY = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var scroll_view_1 = require("../elements/scroll-view");
var client_1 = require("@apollo/client");
var client_2 = require("@apollo/client");
var loader_1 = require("../elements/loader");
var content_1 = require("../elements/content");
var use_lang_1 = require("../../hooks/use-lang");
// -------- Queries -------->
exports.TERMS_CONTENT_QUERY = (0, client_2.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query TermsContentQuery {\n    termsContent {\n      text\n      html\n    }\n  }\n"], ["\n  query TermsContentQuery {\n    termsContent {\n      text\n      html\n    }\n  }\n"])));
exports.TermsContentScrollViewDefaultProps = {};
// --------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-align: left;\n    border-top: 1px solid ", ";\n  "], ["\n    text-align: left;\n    border-top: 1px solid ", ";\n  "])), theme_1.theme.COLOR('line-subtle'))
});
var LoaderContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    min-height: 100px;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-top: 1px solid ", ";\n  "], ["\n    min-height: 100px;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-top: 1px solid ", ";\n  "])), theme_1.theme.COLOR('line-mid'))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: ", ";\n    padding-bottom: 70px;\n  "], ["\n    padding: ", ";\n    padding-bottom: 70px;\n  "])), theme_1.theme.UNIT(7))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(scroll_view_1.ScrollView)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  LoaderContainer: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LoaderContainerStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  Content: (0, styled_components_1.default)(content_1.Content)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
var TermsContentScrollView = function (props) {
  var className = props.className;
  var t = (0, use_lang_1.useLang)();
  var _a = (0, client_1.useQuery)(exports.TERMS_CONTENT_QUERY),
    loading = _a.loading,
    _b = _a.data,
    data = _b === void 0 ? {
      termsContent: {
        html: ''
      }
    } : _b;
  if (loading) {
    return react_1.default.createElement(My.LoaderContainer, null, react_1.default.createElement(My.Loader, {
      spinnerSize: 18
    }, t('Fetching Terms. Please wait...')));
  }
  var termsContent = data.termsContent;
  var html = termsContent.html;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Content, {
    verySmall: true,
    html: html
  }));
};
exports.TermsContentScrollView = TermsContentScrollView;
exports.TermsContentScrollView.defaultProps = exports.TermsContentScrollViewDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;